export default __webpack_public_path__ + "static/media/doctor3.0de4b60c.jpg";